import React from 'react';
import Security from '../../pageComponents/Security';

const SecurityPage = () => <Security />;

export default SecurityPage;
